import * as segmentHelper from './segment-helper'
import { adaptToSegmentUser } from './segment-utils'
import { SegmentUser } from './segment.types'
import { segmentAnalytics } from '@/scripts/app-configs/segment-config'

const identify = (userId: string, traits?: Record<string, unknown>) => {
  segmentAnalytics.identify(userId, traits)
}

const page = (name?: string, properties?: Record<string, unknown>) => {
  segmentAnalytics.page(name, properties)
}

const track = (event: string, properties?: Record<string, unknown>) => {
  segmentAnalytics.track(event, properties)
}

const group = (groupId: string, properties?: Record<string, unknown>) => {
  segmentAnalytics.group(groupId, properties)
}

/* Retrieves the Segment user data after the client is fully initialized */
const getSegmentUserInstance = (): SegmentUser | null => {
  const user = segmentAnalytics.instance?.user()

  return adaptToSegmentUser(user)
}

/* Retrieves the Segment user data asynchronously, safe to call anytime */
const getSegmentUser = async (): Promise<SegmentUser | null> => {
  const user = await segmentAnalytics.user()

  return adaptToSegmentUser(user)
}

/* Low-level Segment SDK methods for internal use in segment-helper */
export const segmentSDK = {
  identify,
  page,
  track,
  group,
  getSegmentUserInstance,
  getSegmentUser,
}

/* Main Segment API - use this for most of all Segment tracking */
export const segment = {
  ...segmentHelper,
  resetUser: () => {
    // Clears the identified user but keeps the same anonymousId.
    // This avoids losing session continuity across tabs in internal environments.
    segmentAnalytics.identify(null)
  },
}
